<template>
    <div>
        <b-row>
            <b-col>
                <div class="alert alert-info mt-3">
                    Total Listas de chequeo: <b-badge>{{ data.total }}</b-badge>
                </div>
            </b-col>
        </b-row>
        <app-data-table
            :fields="fields"
            :items="tableData"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            @sort="onSort"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >

            <template slot="created_at" slot-scope="{ item }">
                {{ item.created_at | datetime }}
            </template>

            <template slot="details" slot-scope="data">
                <b-button size="sm" v-if="!data.item.detailsShowing" :disabled="!data.item.details.length" @click.stop="data.toggleDetails" variant="primary"><i class="fa fa-search-plus" aria-hidden="true"></i> Ver</b-button>
                <b-button size="sm" v-else variant="danger" @click.stop="data.toggleDetails"><i class="fa fa-search-minus" aria-hidden="true"></i> Cerrar</b-button>
            </template>

            <template slot="row-details" slot-scope="data">
                <div class="d-flex justify-content-center">
                    <div class="w-75">
                        <b-table fixed small :fields="fieldsDetails" :items="data.item.details">
                            <template slot="valid" slot-scope="{ item }">
                                <div v-if="item.valid == 1" class="alert alert-success">
                                    Cumple
                                </div>
                                <div v-if="item.valid == 0" class="alert alert-danger">
                                    No Cumple
                                </div>
                                <div v-if="item.valid == -1" class="alert alert-info">
                                    N/A
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: [
                {
                    key: 'created_at',
                    label: 'Fecha'
                },
                {
                    key: 'user.name',
                    label: 'Supervisor'
                },
                {
                    key: 'client.name',
                    label: 'Cliente'
                },
                {
                    key: 'details',
                    label: 'Lista de chequeo',
                    sortable: false
                },
            ],
            fieldsDetails: [
                {
                    key: 'supervision_checklist.supervision_checklist_category.name',
                    label: 'Categoria pregunta'
                },
                {
                    key: 'supervision_checklist.name',
                    label: 'Pregunta'
                },
                {
                    key: 'valid',
                    label: 'Chequeo'
                },
                {
                    key: 'notes',
                    label: 'Notas'
                },
                
            ]
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];

            return this.data.data;
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        }
    },
}
</script>